import axios, { isAxiosError } from "axios"
import { useEffect, useRef, useState } from "react"
import Select from "react-dropdown-select"
import { useSearchParams } from "react-router-dom"
import { metaCategories, metaCategoriesMen } from "../../constants"
import Loadingwrapper from "../../component/LoadingWrapper"
import DemandForecastTable from "./DemandForecastTable"
import dayjs from "dayjs"


const TRENDSTYPEOPTIONS = [
  { value: '', label: 'ALL TRENDS' },
  { value: 'color-pattern', label: 'COLOR & PATTERN TRENDS' },
  { value: 'silhouette', label: 'SILHOUETTE TRENDS' },
  { value: 'attribute', label: 'ATTRIBUTE TRENDS' }
]

const FORECASTTYPEOPTIONS = ["Trend First", "Balanced", "Stability"]

const DemandForecast = ({ }) => {
  const currentDate = useRef(new Date())
  const [searchParams, setSearchParams] = useSearchParams({ gender: "F", category: "Topwear", geography: "", sort: "rog", trends: "" })
  const [trends, setTrends] = useState([])
  const [loading, setLoading] = useState(true)
  const [count, setCount] = useState(0)
  const [unitsToSell, setUnitsToSell] = useState(10000)
  const [forecastType, setForecastType] = useState(FORECASTTYPEOPTIONS[0])

  useEffect(() => {
    setSearchParams(prev => {
      prev.set('category', prev.get('gender') == "F" ? "Topwear" : "Shirts")
      return prev
    })
  }, [searchParams.get('gender')])

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal
    getTrends(signal);
    return () => {
      abortController.abort()
    }
  }, [searchParams.get('gender'), searchParams.get('category'), searchParams.get('geography')])

  const getTrends = async (signal) => {
    setLoading(true)
    try {
      const response = await axios.get(`/api/demand-forecast/trends?gender=${searchParams.get('gender')}&category=${searchParams.get('category')}&geography=${searchParams.get('geography').toLowerCase()}`, { signal })
      setTrends(response.data.trends)
      setCount(response.data.count)
      setLoading(false)
    } catch (e) {
      if (!isAxiosError(e)) {
        console.error(e)
        setLoading(false)
      }
    }
  }


  return <div>
    <div className="z-40 bg-white sticky top-0">
      <h2 className="text-[30px] text-center  -mb-2 font-semibold">Fast Fashion Demand Forecast</h2>
      <h3 className="text-lg italic text-center m-2 text-slate-600">Period: {dayjs(currentDate.current).add(20, 'day').format('DD MMMM YYYY')}-{dayjs(currentDate.current).add(50, 'day').format('DD MMMM YYYY')}</h3>
      <div className="flex px-2">

        <div className='m-1'>
          <Select
            key={'gender' + window.location.href}
            placeholder={'Gender'}
            options={[{ value: 'F', label: 'Female' }, { value: 'M', label: 'Male (Beta)' }]}
            valueField={'value'}
            labelField={'label'}
            values={searchParams.get('gender') == 'F' ? [{ value: 'F', label: 'Female' }] : [{ value: 'M', label: 'Male (Beta)' }]}
            onChange={(values) => setSearchParams(prev => {
              prev.set('gender', values[0].value)
              return prev;
            })}
            searchable={false}
            className='px-2 rounded py-0 lg:py-1 border-slate-300 border m-0  lg:m-1 bg-slate-200  min-w-40 flex flex-wrap'
            wrapperClassName='m-0 lg:m-2 w-40 '
          />
        </div>
        <div className='m-1'>
          <Select
            key={'category' + window.location.href}
            placeholder={'Category'}
            options={[{ value: 'All', label: 'All Categories' }, { value: "apparel", label: "Apparel" }, { value: "non-apparel", label: "Non Apparel" },
            ...((searchParams.get('gender') == 'M' ? metaCategoriesMen : metaCategories).map(cat => ({ value: cat, label: cat })))]}
            values={[{ value: searchParams.get('category'), label: searchParams.get('category') == 'All' ? 'All Categories' : searchParams.get('category') }]}
            onChange={(values) => setSearchParams(prev => {
              prev.set('category', values[0].value)
              return prev;
            })}
            searchable={false}
            className='px-2 rounded py-0 lg:py-1 border-slate-300 border m-0  lg:m-1 bg-slate-200  min-w-40 flex flex-wrap'
            wrapperClassName='m-0 lg:m-2 w-40 '
          />
        </div>

        <div className='m-1'>
          <Select
            key={'geography' + window.location.href}
            placeholder={'Geography'}
            options={[{ value: '', label: 'All geography (Recommended)' }, ...(['Asian', 'Indian', 'Western'//, 'Asian,Western'
            ].map(t => ({ value: t, label: t == 'Asian,Western' ? 'Asian + Western' : t })))]}
            values={[{ value: searchParams.get('geography'), label: searchParams.get('geography') == '' ? 'All geography (Recommended)' : searchParams.get('geography') == 'Asian,Western' ? 'Asian + Western' : searchParams.get('geography') }]}
            onChange={(values) => setSearchParams(prev => {
              prev.set('geography', values[0].value)
              return prev;
            })}
            searchable={false}
            className='px-2 rounded py-0 lg:py-1 border-slate-300 border m-0  lg:m-1 bg-slate-200  min-w-40 flex flex-wrap'
            wrapperClassName='m-0 lg:m-2 w-40 '
          />
        </div>

        <div className='m-1'>
          <Select
            key={'trends' + window.location.href}
            placeholder={'Trends'}
            options={TRENDSTYPEOPTIONS}
            values={TRENDSTYPEOPTIONS.filter(t => t.value == searchParams.get('trends'))}
            onChange={(values) => setSearchParams(prev => {
              if (values[0]) {
                prev.set('trends', values[0].value)
              }
              else {
                prev.set('trends', '')
              }
              return prev;
            })}
            searchable={false}
            className='px-2 rounded py-0 lg:py-1 border-slate-300 border m-0  lg:m-1 bg-slate-200  min-w-40 flex flex-wrap'
            wrapperClassName='m-0 lg:m-2 w-40 '
          />
        </div>
        <div className='m-1'>
          <Select
            key={'trends' + window.location.href}
            placeholder={'Forecast type'}
            options={FORECASTTYPEOPTIONS.map(t => ({ label: t, value: t }))}
            values={[{ label: forecastType, value: forecastType }]}
            onChange={(values) => setForecastType(values[0].value)}
            searchable={false}
            className='px-2 rounded py-0 lg:py-1 border-slate-300 border m-0  lg:m-1 bg-slate-200  min-w-40 flex flex-wrap'
            wrapperClassName='m-0 lg:m-2 w-40 '
          />
        </div>
      </div>
    </div>
    <div className="px-2 mb-2">
      <label className="mr-2">Sales Target</label>
      <input
        type="text"
        value={unitsToSell == "" ? 0 : `${unitsToSell}`}
        className="border bg-slate-50 rounded px-2 outline-none"
        onChange={(e) => {
          const newValue = e.target.value;
          if (newValue == "") {
            setUnitsToSell(0)
            return
          } if (!isNaN(parseInt(e.target.value))) {
            setUnitsToSell(parseInt(newValue))
          }
        }}
      />

    </div>

    <Loadingwrapper loading={loading} className={"my-48 "}>
      <DemandForecastTable trends={trends} unitsToSell={unitsToSell} searchParams={searchParams} forecastType={forecastType} FORECASTTYPEOPTIONS={FORECASTTYPEOPTIONS} />



    </Loadingwrapper>
  </div>

}


export default DemandForecast
